<ng-container *ngIf="CurrencyActive">
  <img [src]="CurrencyActive.img_flag" class [ngStyle]="{'width':WithImg}"
    alt="{{CurrencyActive.currency}}">
  {{CurrencyActive.currency}}
</ng-container>
